/* Fun Cases — cart page interactivity.
   Qty / remove / gift / upsell changes hit the AJAX Cart API then reload, so the
   server re-renders prices, bars and the gift picker (no client-side money markup
   to mishandle). Plus a recommendations cross-sell row and the EUR duty gate. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cart-page]');
  if (!root) return;

  var fmt = window.__fcMoney || '£{{amount}}';
  var busy = false;
  function money(c) { return fmt.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, (c / 100).toFixed(2)); }
  function esc(s) { return (s == null ? '' : '' + s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function thumb(u) { if (!u) return ''; if (u.indexOf('res.cloudinary.com') > -1) { if (u.indexOf('/image/upload/') > -1 && u.indexOf('/image/fetch/') === -1) { return u.replace('/image/upload/', '/image/upload/w_160,c_limit,f_auto,q_auto/'); } return u; } return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function change(key, qty) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }); }
  function addVariant(id, qty, props) { var it = { id: id, quantity: qty || 1 }; if (props) it.properties = props; return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [it] }) }).then(function (r) { return r.json(); }); }
  function reload() { window.location.reload(); }

  root.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-qty]');
    if (qb) {
      e.preventDefault(); if (busy) return; busy = true;
      var line = qb.closest('.cart-line'), key = line.getAttribute('data-key');
      var cur = parseInt(line.querySelector('[data-qty-val]').textContent, 10) || 0;
      var next = cur + parseInt(qb.getAttribute('data-qty'), 10);
      line.style.opacity = '.5';
      change(key, next < 0 ? 0 : next).then(reload);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault(); if (busy) return; busy = true;
      var l = rm.closest('.cart-line'); l.style.opacity = '.5';
      change(l.getAttribute('data-key'), 0).then(reload);
      return;
    }
    var gadd = e.target.closest('[data-gift-add]');
    if (gadd) {
      e.preventDefault(); if (busy) return; busy = true; gadd.classList.add('is-loading');
      var card = gadd.closest('.gift-card'), sel = card && card.querySelector('[data-gift-variant]');
      var vid = sel ? sel.value : gadd.getAttribute('data-gift-add');
      addVariant(parseInt(vid, 10), 1, { _free_gift: 'true' }).then(reload);
      return;
    }
    var radd = e.target.closest('[data-rec-add]');
    if (radd) {
      e.preventDefault(); if (busy) return; busy = true; radd.classList.add('is-loading');
      addVariant(parseInt(radd.getAttribute('data-rec-add'), 10), 1).then(reload);
      return;
    }
  });

  /* EUR: gate checkout behind the taxes-&-duties acknowledgement. */
  var checkout = root.querySelector('[data-checkout-gated]');
  var dutyAck = root.querySelector('[data-duty-ack]');
  if (checkout && dutyAck) {
    checkout.addEventListener('click', function (e) {
      if (!dutyAck.checked) { e.preventDefault(); var d = root.querySelector('[data-duty]'); if (d) d.classList.add('cart-duty--warn'); }
    });
    dutyAck.addEventListener('change', function () {
      checkout.setAttribute('aria-disabled', dutyAck.checked ? 'false' : 'true');
      if (dutyAck.checked) { var d = root.querySelector('[data-duty]'); if (d) d.classList.remove('cart-duty--warn'); }
    });
  }

  /* Upsell forms on the page → AJAX add then reload (pre-empt the global drawer handler). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-upsell-form]');
    if (!form || !root.contains(form)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }).then(reload).catch(function () { form.submit(); });
  }, true);

  /* Cross-sells via the recommendations API — only when no curated upsell collection is set. */
  var recsEl = root.querySelector('[data-cart-recs]');
  if (recsEl && !root.querySelector('.cart-pg__upsells')) {
    var seed = recsEl.getAttribute('data-seed');
    var model = recsEl.getAttribute('data-model') || '';
    var inbag = {}; (recsEl.getAttribute('data-incart') || '').split(',').forEach(function (id) { if (id) inbag[id] = true; });
    if (seed) {
      fetch('/recommendations/products.json?product_id=' + seed + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = (data.products || []).filter(function (p) { return !inbag[p.id]; }).slice(0, 4);
          if (!list.length) return;
          recsEl.innerHTML = '<h2 class="pdp-upsells__head">You might also need&hellip;</h2>' +
            list.map(function (p) {
              var v = null;
              if (model && p.variants) { for (var j = 0; j < p.variants.length; j++) { if (p.variants[j].option1 === model || p.variants[j].title === model) { v = p.variants[j]; break; } } }
              if (!v) v = (p.variants && p.variants[0]) || {};
              var img = p.featured_image || (p.images && p.images[0]) || '';
              return '<div class="cart-rec">' +
                '<a href="' + p.url + '" class="cart-rec__img">' + (img ? '<img src="' + thumb(img) + '" alt="" loading="lazy">' : '') + '</a>' +
                '<div class="cart-rec__info"><a href="' + p.url + '" class="cart-rec__title">' + esc(p.title) + '</a>' +
                '<span class="cart-rec__price">' + money(v.price != null ? v.price : p.price) + '</span></div>' +
                '<button type="button" class="cart-rec__add" data-rec-add="' + v.id + '" aria-label="Add ' + esc(p.title) + '">+</button>' +
              '</div>';
            }).join('');
          recsEl.hidden = false;
        }).catch(function () {});
    }
  }
})();
